import Link from 'next/link'
import React, { forwardRef, ReactNode } from 'react'
import { PolyRefFunction } from 'react-polymorphed'
import { twMerge } from 'tailwind-merge'

const polyRef = forwardRef as PolyRefFunction

type LinkButtonProps = {
  children: ReactNode
  href: string
}

interface Props {
  className?: string
}

const PrimaryButton = polyRef<'button', Props>(({ as: As = 'button', className, ...rest }, ref) => {
  return (
    <As
      className={twMerge(
        `
          block rounded bg-ui-primary px-4 py-2 text-center text-white

          
        `,
        className
      )}
      ref={ref}
      {...rest}
    ></As>
  )
})

const SecondaryButton = polyRef<'button', Props>(({ as: As = 'button', className, ...rest }, ref) => {
  return (
    <As
      className={`
        block rounded bg-ui-secondary px-6 py-3

        text-whitehover:bg-ui-secondary/90

        ${className}
      `}
      ref={ref}
      {...rest}
    ></As>
  )
})

const LinkButton: React.FC<LinkButtonProps> = ({ children, href }) => {
  return (
    <Link
      href={href}
      className={`
        px-6 text-ui-primary

        hover:text-ui-primary/90py-3
      `}
    >
      {children}
    </Link>
  )
}

export { LinkButton, PrimaryButton, SecondaryButton }
